import { reactive, toRefs, onBeforeMount, getCurrentInstance, onMounted, ref, computed, Ref, nextTick, watch, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import useReceiveMessage, { getCanvasLimitHeight } from '@/hooks/useReceiveMessage'
import {
    enterOrExitUavSimulateModule,
    switchOpenGuid,
    switchView,
    resetView,
    switchUnlockUav,
    oneKeyReturn,
    switchShootingMode,
    shoot,
    setZoom,
    forceGainFocus, stopReturn, switchFlyMode,setPause,updateBatteryStatus
} from '@/webapi'
import { $enum, $config, $tips } from '@/global'
import { getAirLineDetailNew, createTraining, exportAirLinePointActions,saveUserTrainingSetting,getDefaultTrainingSetting } from '@/service'
import { gsap } from "gsap";
import useLoading3D from '@/hooks/useLoading3D'
import type { CountdownProps } from 'naive-ui'
import {useRouter, useRoute} from 'vue-router'
import useSpeechSynthesis from '@/hooks/useSpeechSynthesis'
import {createRandomWind,downloadFile} from '@/utils/index'
import { SystemMode } from '@/types/system'

interface IFlyingEmit {
    (event: 'onBack'): void
}

enum PageName {
    加载中=1,
    飞行=2,
    音频=3,
    成绩=4,
    提示=5,
    辅助线=6,
}

enum AlertType {
    无 = 0,
    限制区域 = 1,
    电量预警 = 2,
    电量告警 = 3,
}

enum SceneCategory {
    考核=1,
    训练=2,
    通关=4,
    技能考评=10,
    无=-1,
}

enum FlyMode {
    姿态=0,
    GPS=1,
    混合=2,
    无=-1,
}

//报警类型
enum AlarmType {
    操作=1,
    异常=2
}

enum MassageType {
    无=0,
    解锁=1,
    巡检=2,
    完成=3,
    碰撞=4,
    高度限制=5,
    图片不合格=6
}

//视角模式 0：跟随视角(第三人称) 1：图传视角(第一人称) 2：飞手视角
enum CharacterMode {
    跟随视角=0,
    图传视角=1,
    飞手视角=2,
}

enum SignalStrength {
    无=0,
    弱=1,
    中=2,
    强=3,
}

export default function useTransmit(
    emit: IFlyingEmit,
    audioIconRef: any,
    biaopan: any,
    homePos: any,
    homeIcon: any,
    progressRef: any,
    timeBox: any,
    progressBox: any,
    stayPosRef: any,
) {
    ////////////////////////////////////////////////// 状态
    const store = useStore()
    const router = useRouter()
    const typeMap = new Map([
        ['notifyRunningParam', 'notifyRunningParam'], //运行数据回调
        ['loadResourceFail', 'loadResourceFail'], //加载模型失败
        ['loadSceneResource', 'loadSceneResource'], //加载模型完成
        ['modelLoading', 'modelLoading'], //加载模型进度
        ['initializeEngineProgress', 'initializeEngineProgress'], //引擎初始化
        ['notifyReferenceImage', 'notifyReferenceImage'], //参考图片回调
        ['notifyActionEvaluateParams', 'notifyActionEvaluateParams'] ,// 画面占比标准值
        ['extraLoadModelFiles','extraLoadModelFiles'], //额外的模型文件列表
        ['exitSimulateModuleSuccess','exitSimulateModuleSuccess'], //退出模拟模块成功
    ])
    const { proxy } = getCurrentInstance()!
    const state = reactive({
        sceneImage: $config.FILE_ROOT_PATH + store.state.persistence.currentUavInfo.sceneImageUrl,
        parentName: store.state.persistence.currentUavInfo.parentName,
        uavId: store.state.persistence.currentUavInfo.uavId,
        nestId: store.state.persistence.currentUavInfo.nestId,
        stationdId: store.state.persistence.stationId,
        sceneInfo: store.state.persistence.currentUavInfo.sceneInfo,
        maxHeight: store.state.persistence.currentUavInfo.heightLimit,
        // maxHeight: 5,
        windSpeedIndex:store.state.persistence.currentUavInfo.windSpeedIndex,
        windDirectionIndex:store.state.persistence.currentUavInfo.windDirectionIndex,
        maxHolderPitch:store.state.persistence.currentUavInfo.maxHolderPitch,
        minHolderPitch:store.state.persistence.currentUavInfo.minHolderPitch,
        pitch:0,//俯仰角
        finish: false,
        uavFlyStatus:$enum.UAV_FLY_STATUS.WAITING,
        battery: 100 as any, //电池,
        connectStatus: $enum.CommonStatus.close,
        totalSeconds: store.state.persistence.currentUavInfo.flyTime * 60,
        currentSeconds: store.state.persistence.currentUavInfo.flyTime * 60,
        // totalSeconds:120,
        // currentSeconds:60,
        lockStatus:$enum.CommonStatus.close,
        audioMode:$enum.AUDIO_MODE.PHOTO,
        videoStatus:$enum.CommonStatus.close,
        photoStatus:$enum.CommonStatus.close,
        recordTime:0, //录制时间
        showAudioView:false, //是否显示音频
        photoPic:null,
        isShowAudio:false,
        currentPage:PageName.加载中, //当前页面,
        resourceFileList:store.state.persistence.currentUavInfo?.resourceFileList[0] || [],
        /////////////////////////////////////// 变焦
        currentZoom:1.0,//当前变焦
        zommStep: 0.5,             // 步进值
        scaleMarks: [] as any[],        // 刻度标记
        scaleRange: 100,        // 刻度条总长度百分比
        minZoom:1.0,
        maxZoom: store.state.persistence.currentUavInfo.maxZoom,

        ////////////////////////////////////// 表盘
        angleValue:0, //角度
        speedValue: 0,//速度
        altitudeValue: 0,//高度
        relativeAltitude:0,//相对起始点的高度
        horizontalDistance:0,//相对起始点的水平距离
        yawAngle:0,//返航点角度

        typeMap: new Map([
            ['notifyRunningParam','notifyRunningParam'], //运行数据回调
        ]),

        routerFrom:null,
        routerTo:null,
        totalRotation: 0,
        homeAngle: 0,
        maxHorizontalDistance: 500,//最大水平距离
        homeIconW:0,
        homeIconH:0,
        homeOutW:0,
        homeOutH:0,
        isComputing:false,//是否开启无人机电池使用时间记录
        timer:null as any, //定时器
        step: 1,
        containerWidth:0 as any,
        onGround:false, //是否在地面
        isShowTaskList:false, //是否显示任务列表
        guidStatus:store.state.persistence.userTrainSettingInfo?.enableGuide, //引导状态
        startCoundow:false,//开启倒计时
        taskList:[] as any[],
        currentTask:-1,//当前选中的任务下标
        sceneIsLoaded:false,
        currentPointIndex:0,
        isShowMessage:false,
        fromToAudio:PageName.飞行, //从哪里跳转
        isShowAlarm:false,
        alarmTimer:null as any, //定时器
        alarmTimeCount:0, //定时器
        alertType:AlertType.无, //警告类型
        animationId: null as any, //动画id,
        startTime: 0,
        remainingSeconds: 0,
        pageVisible:true,
        engineProgress:0,
        loading3D:{
            title:store.state.persistence.currentUavInfo.sceneInfo?.sceneSubTypeName,
            description:store.state.persistence.currentUavInfo.sceneInfo?.typeDescription,
            pageType:store.state.persistence.currentUavInfo.parentName,
        },
        fpsStatus:60,
        canSetFps:true,
        currentWindSpeed:'0.0',
        isReady:false,
        currentFlyMode:FlyMode.GPS,
        alarmType:AlarmType.操作,
        promptText:'',
        currentMessage:MassageType.无,
        isAlwaysVisibleAi:true,
        characterMode:CharacterMode.跟随视角,
        referencePhoto:'',
        totalTime:0,//总时间
        crash:false,
        gradScore:0,//得分
        evaluate:false,//评估
        completedPhotoCount:0,//完成的照片数量
        passedPhotoCount:0,//通过的照片数量
        allPhotoCount:0,//所有照片数量
        loading:false,
        // isClickBack:false,
        stayPointHorzDistance:0,
        stayPointYaw:0,
        stayBoxW:0,
        stayBoxH:0,
        stayPointIconW:0 as any,
        stayPointIconH:0 as any,
        // 目标占比
        targetRatio:0,
        // 标准目标占比
        standardTargetRatio:0,
        // 辅助线设置
        settingConfirmLoading:false,
        settingResetLoading:false,
        crossLine:false,
        gridLine:false,
        centerPoint:false,
        signalStrength:SignalStrength.中,
        galeWarning:false,
        collisionWarningLevels:[0, 0, 0, 0],
        collisionWarningMinDistance:0,
        backByExitSimulateModule:false,
    })
    let isUnmounted = false
    const pendingPromptTimers = new Set<ReturnType<typeof setTimeout>>()

    function schedulePrompt(callback: () => void, delay: number) {
        const timer = setTimeout(() => {
            pendingPromptTimers.delete(timer)
            if(!isUnmounted){
                callback()
            }
        }, delay)
        pendingPromptTimers.add(timer)
    }

    function clearPendingPrompts() {
        pendingPromptTimers.forEach((timer) => clearTimeout(timer))
        pendingPromptTimers.clear()
    }

    const gradTotalTime = computed(() => {
        const totalSeconds = state.totalTime;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds - minutes * 60); // 关键修改：计算真正的剩余秒数
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    });

    //场景管理类型
    const sceneCategory = computed(()=>{
        if(store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId){
            return store.state.persistence.currentUavInfo.sceneInfo?.sceneCategoryId
        }else{
            return SceneCategory.无
        }
    })
    const isAssessmentScene = computed(()=>{
        return sceneCategory.value == SceneCategory.考核
            || sceneCategory.value == SceneCategory.技能考评
    })

    //系统模式
    const systemMode = computed(()=>{
        return store.state.viewData.systemMode
    })

    //技能考评
    const isPilotAssessment = computed(()=>{
        return systemMode.value == SystemMode.PILOT_ASSESSMENT
    })


    ////////////////////////////////////////////////// computed/watch

    const uavCurrentStatus = computed(() => {
        if(state.uavFlyStatus == $enum.UAV_FLY_STATUS.WAITING){
            return '等待中'
          }else if(state.uavFlyStatus == $enum.UAV_FLY_STATUS.FLYING){
            return '飞行中'
          }else if(state.uavFlyStatus == $enum.UAV_FLY_STATUS.BACKING){
            return '返航中'
          }
          return ''
    })

    const batteryIcon = computed(() => {
        if (state.battery >= 0 && state.battery < 1) {
            return require("@/assets/images/batteryLev1.png");
          } else if (state.battery >= 1 && state.battery < 33) {
            return require("@/assets/images/batteryLev2.png");
          } else if (state.battery >= 32 && state.battery < 66) {
            return require("@/assets/images/batteryLev3.png");
          }
          return require("@/assets/images/batteryLev4.png");
    })

    const connectIcon = computed(() => {
        if (state.connectStatus == $enum.CommonStatus.close) {
            return require("@/assets/images/disconnect.png");
          }
          return require("@/assets/images/connect.png");
    })

    const progressTimer = computed(()=>{
        const minutes = Math.floor(state.currentSeconds / 60);
        const seconds = state.currentSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    })

    const lockIcon = computed(() => {
        if(state.lockStatus ==  $enum.CommonStatus.open){
            return require("@/assets/images/unlock.png");
          }
          return require("@/assets/images/lock.png");
    })

    const changeModeIcon = computed(() => {
        if(state.audioMode == $enum.AUDIO_MODE.VIDEO){
            return require("@/assets/images/toChangeVideo.png");
          }
          return require("@/assets/images/toChangePhoto.png");
    })

    const videoIcon = computed(() => {
        if(state.videoStatus == $enum.CommonStatus.close){
            return require("@/assets/images/takeVideo.png");
          }
          return require("@/assets/images/takeingVideo.png");
    })

    const photoIcon = computed(() => {
        if(state.photoStatus == $enum.CommonStatus.close){
            return require("@/assets/images/takePhoto.png");
        }
        return require("@/assets/images/takeingPhoto.png");
    })

    const takeVideoTime = computed(()=>{
        const hours = Math.floor(state.recordTime / 3600);
        const minutes = Math.floor((state.recordTime % 3600) / 60);
        const seconds = Math.floor(state.recordTime % 60);
        return [hours, minutes, seconds].map(unit => unit < 10 ? `0${unit}` : unit).join(':');
    })

    const zoomPoint = computed(()=>{
        return (((state.maxZoom - state.currentZoom) / (state.maxZoom - state.minZoom)) - 0.15) * state.scaleRange + '%';
    })

    //角度转换为百分比位置
    const pitchTop = computed(()=>{
        // 确保角度在有效范围内
        const clampedAngle = Math.max(state.minHolderPitch, Math.min(state.maxHolderPitch, state.pitch));
        //计算百分比位置
        return `${(((clampedAngle - state.minHolderPitch) / (state.maxHolderPitch - state.minHolderPitch)) - 0.05) * 100}%`;
    })

    const dialStyle = computed(()=>{
        return {
            transform: `rotate(${state.totalRotation}deg)`,
            transition: 'transform 0.2s linear'
        }
    })

    const positionStyle = computed(()=>{
        let CENTER_X = (state.homeOutW / 2) - (state.homeIconW / 2);
        let CENTER_Y = (state.homeOutH / 2) - (state.homeIconH / 2);
        let maxRedius = state.homeOutW / 2;

        if(state.horizontalDistance == 0){
            return {
                transform: `translate(${CENTER_X}px, ${CENTER_Y}px)`,
                transition: 'transform 0.05s linear'
            };
        }
        let redius = 0;
        if(state.horizontalDistance >= state.maxHorizontalDistance ){
            redius = state.homeOutW / 2;
        }else {
            redius = maxRedius * (state.horizontalDistance / state.maxHorizontalDistance);
        }
        const angle = (state.homeAngle - 90) * Math.PI / 180;
        const x = CENTER_X + redius * Math.cos(angle);
        const y = CENTER_Y + redius * Math.sin(angle);
        return {
            transform: `translate(${x}px, ${y}px)`,
            transition: 'transform 0.05s linear'
        };
    })

    const stayPointStyle = computed(()=>{
        let CENTER_X = (state.stayBoxW / 2) - (state.stayPointIconW / 2);
        let CENTER_Y = (state.stayBoxH / 2) - (state.stayPointIconH / 2);
        let maxRedius = state.stayBoxW / 2;

        if(state.stayPointHorzDistance == 0){
            return {
                transform: `translate(${CENTER_X}px, ${CENTER_Y}px)`,
                transition: 'transform 0.05s linear'
            };
        }
        let redius = 0;
        if(state.stayPointHorzDistance >= state.maxHorizontalDistance ){
            redius = state.stayBoxW / 2;
        }else {
            redius = maxRedius * (state.stayPointHorzDistance / state.maxHorizontalDistance);
        }
        // console.log('stayPointStyle----',state.stayPointHorzDistance, state.stayPointYaw, CENTER_X, CENTER_Y, redius)
        const angle = (state.stayPointYaw - 90) * Math.PI / 180;
        const x = CENTER_X + redius * Math.cos(angle);
        const y = CENTER_Y + redius * Math.sin(angle);
        const style = {
            transform: `translate(${x}px, ${y}px)`,
            transition: 'transform 0.05s linear'
        } as any
        if(redius > 3){
            style.color = '#E70102'
            style.animation = "blink-soft 1s infinite alternate"
        }else{
            style.color = '#2174FF'
        }
        return style;
    })

    const interComeplate = computed(()=>{
        return state.sceneIsLoaded && state.taskList.length > 0
    })

    const currentTaskInfo = computed(()=>{
        return state.taskList[state.currentTask]
    })

    const currentPoint = computed(()=>{
        if(state.currentPointIndex < state.taskList[state.currentTask]?.pointList.length){
            return state.taskList[state.currentTask]?.pointList[state.currentPointIndex]
        }else{
            return state.taskList[state.currentTask]?.pointList[state.taskList[state.currentTask]?.pointList.length - 1]
        }

    })
    const percentage = computed(()=>{
        if(state.taskList.length == 0 || state.currentPointIndex == 0){
            return 0;
        }else{
            const progressPercentage = (state.currentPointIndex / state.taskList[state.currentTask]?.pointList.length) * 100
            return progressPercentage.toFixed(0);
        }
    })

    const loadingProgess = computed(() => {
        if(engineInitialized.value){
            return loadingState.progressValue;
        }else{
            return (state.engineProgress * 100).toFixed(2);
        }
    });

    const showTargetProgress = computed(()=>{
        return sceneCategory.value == SceneCategory.训练 && state.isReady && state.characterMode == CharacterMode.图传视角
    })

    const trainingId = computed(()=>{
        return store.state.persistence.currentUavInfo.trainingId
    })

    watch(()=>interComeplate.value,(newValue)=>{
        if(newValue){
            let flyMode;
            let windSpeed;
            let windDirection;
            if(sceneCategory.value == SceneCategory.训练 || (sceneCategory.value == SceneCategory.通关 && state.sceneInfo?.difficultyType == 0)){
                flyMode = FlyMode.GPS
            }

            if(isAssessmentScene.value || (sceneCategory.value == SceneCategory.通关 && state.sceneInfo?.difficultyType == 1)){
                flyMode = FlyMode.混合
            }
            if(sceneCategory.value == SceneCategory.训练 || sceneCategory.value == SceneCategory.通关){
                windSpeed = state.windSpeedIndex
                windDirection = state.windDirectionIndex
            }else if(isAssessmentScene.value){
                windSpeed = createRandomWind().speed
                windDirection = createRandomWind().direction
            }
            enterOrExitUavSimulateModule({
                enter:true,
                uavSpecificationId:state.uavId,
                nestId:state.nestId,
                userId:store.state.persistence.userInfo.userId,
                tenantId:store.state.persistence.currentTenantId,
                flyTime:store.state.persistence.currentUavInfo.flyTime,
                volume:store.state.persistence.sounds.droneSound,
                canvasLimitHeight:getCanvasLimitHeight(store.state.persistence.resolution),
                openGuidStatu:state.guidStatus,
                trainingData:{
                    id:trainingId.value,
                    sceneInfo:state.sceneInfo,
                    airLineData:currentTaskInfo.value,
                    windSpeedRange:windSpeed,
                    windDirectionIndex:windDirection,
                    forbidSaveResult:'',
                    flyMode,
                    specifiedJoystick:store.state.persistence.userTrainSettingInfo.joystickSpecification
                },
            })
        }
    })

    watch(()=>state.photoPic,(newValue)=>{
        if(newValue){
            if(!state.showAudioView){
                state.showAudioView = true;
                let container = null as any;
                if(audioIconRef.value){
                    container = audioIconRef.value.getBoundingClientRect()
                }
                let contT = window.innerHeight - container.top - (container.height / 2);
                let contL = window.innerWidth - container.left - (container.width / 2);
                gsap.delayedCall(0.15, () => {
                    gsap.to('.photo-review-box', {
                    duration: 0.1,
                    scale: 0.5,
                    ease:'power1',
                    onComplete: () => {
                        gsap.to('.photo-review-box', {
                        duration: 0.5,
                        width: 0,
                        height: 0,
                        bottom: contT.toFixed(0)+'px',
                        right: contL.toFixed(0)+'px',
                        scale: 0.2,
                        ease:'power1',
                        onComplete: () => {
                            state.showAudioView = false;
                        }
                        });
                    }
                });
              });
            }
        }
    })

    watch(()=>state.lockStatus,(newValue, oldVal)=>{
        if(newValue == $enum.CommonStatus.open){
            if(!state.isComputing){
              startProgress();
            }
          }else if(newValue == $enum.CommonStatus.close){
            if(state.isComputing){
              stopProgress();
            }
         }
    })

    let skipDialRotationWatch = false;

    watch(()=>state.angleValue,(newVal, oldVal)=>{
        if (skipDialRotationWatch || oldVal === undefined) return;
        let delta = ((Number(newVal) - Number(oldVal) + 360) % 360)
        if (delta > 180) delta -= 360;
        state.totalRotation -= delta;
    })

    watch(()=>state.battery,(newValue, oldValue)=>{
        if(newValue >= 12 && newValue < 20  && state.alertType != AlertType.电量预警){
            state.alertType = AlertType.电量预警;
        }else if(newValue >= 0 && newValue < 12 && !state.alarmTimer && state.alertType != AlertType.电量告警 && state.currentMessage != MassageType.高度限制){
            state.alertType = AlertType.电量告警;
            controlAlarm(true);
        }
        if(newValue <= 12 && oldValue > 12){
            updateBatteryStatus({status:1});
        }
        if(newValue == 0 && oldValue > 0){
            updateBatteryStatus({status:2});
        }
    })

    watch(()=>state.relativeAltitude,(newVal, oldVal)=>{
        if(newVal > state.maxHeight && state.alertType != AlertType.电量告警  &&  state.currentMessage != MassageType.高度限制){
            state.isShowAlarm = true;
            state.currentMessage = MassageType.高度限制;
            state.alarmType = AlarmType.异常;
            if(sceneCategory.value == SceneCategory.训练){
                // showMessage(`你已进入限制区域，训练即将结束。`, "warning", 3000, 'gjts')
                controlAlarm(true);
            }else if(sceneCategory.value == SceneCategory.通关){
                showMessage(`你已进入限飞区域，通关失败。`, "warning", 3000, 'gjts')
            }else if(isAssessmentScene.value){
                showMessage(`你已进入限飞区域，考核不通过。`, "warning", 3000, 'gjts')
            }
        }

        if(newVal <= state.maxHeight && state.currentMessage == MassageType.高度限制){
            if(state.currentMessage == MassageType.高度限制){
                state.currentMessage = MassageType.无;
                state.alarmType = AlarmType.操作;
                state.isShowAlarm = false;
            }
            if(sceneCategory.value == SceneCategory.训练){
                state.promptText = ''
                controlAlarm(false);
            }
        }
    })

    const { speak, stop} = useSpeechSynthesis()


    const controlAlarm = (status:boolean) => {
        if(state.alarmTimer){
            clearInterval(state.alarmTimer);
            state.alarmTimer = null;
        }
        if(status){
            state.alarmTimeCount = 10;
            if(state.currentMessage == MassageType.高度限制){
                // showMessage(`你已进入限制区域，训练即将结束。`, "warning", 0, 'gjts')
                showMessage(`你已进入限制区域，${state.alarmTimeCount}秒后将自动结束训练。`, "warning", 0, 'gjts')
            }
            state.alarmTimer = setInterval(() => {
                state.alarmTimeCount--;
                if(state.alarmTimeCount == 0){
                    state.isShowMessage = false;
                    proxy?.vknMessage.close();
                    clearInterval(state.alarmTimer);
                    state.alarmTimer = null;
                    state.isShowAlarm = false;
                    if(state.alertType == AlertType.电量告警 && state.uavFlyStatus == $enum.UAV_FLY_STATUS.FLYING){
                        handleBackHome(true);
                    }
                }
            }, 1000);
        }else{
            proxy?.vknMessage.close();
            if(state.isShowMessage){
                state.isShowMessage = false;
            }
        }
    }

    const showMessage = (message: string, type:"yellowAlert" | "redAlert" | "warning" , duration?:number, icon?:string) => {
        if(isUnmounted) return
        if(sceneCategory.value == SceneCategory.训练){
            state.promptText = message;
        }else{
            speak(message)
            state.isShowMessage = true;
            proxy?.vknMessage[type]({
                message: message,
                duration:duration !== null && duration !== undefined?duration:3000,
                offset: 100,
                onClose: () => {
                    state.isShowMessage = false;
                }
            }, icon)
        }
    }

    const showErrorMessage = (message: string, offset = 100) => {
        state.isShowMessage = true;
            proxy?.vknMessage["redAlert"]({
                message: message,
                duration:3000,
                offset: offset,
                onClose: () => {
                    state.isShowMessage = false;
                }
            }, 'gjts')
    }
    const stationList = store.state.persistence.currentUavInfo.sceneInfo?.stationList || []
    const airlineId = stationList[0]?.airLineId || null
    ///////////////////////////////////////////////////////  事件
    const { loadingState, setLoadingStatus,engineInitialized,handleOpenPDF ,setExtraFileMap, showOrHideEngineView } = useLoading3D(state.stationdId, state.resourceFileList, proxy,{
        airLineId:airlineId,
        difficultyType:store.state.persistence.currentUavInfo.sceneInfo?.difficultyType,
    })

    const { handleOpenSettingFullscreen } = useReceiveMessage(typeMap, (type: string, data: any) => {
        if (type === 'notifyRunningParam') {
            const { altitude, flyStatu, homingData, horizonalSpeed, joyStickMode, unLockStatu, verticalSpeed, yaw, yawAngleSpeed, zoom, pitch, shootingMode, recordTime, photoPic,onGround,
                taskData,openGuidStatu,notifyKeyList,triggerReset,fps,currentWindSpeed,isReady,currentFlyMode,characterMode,signalStrength,galeWarning, collisionWarningLevels, collisionWarningMinDistance   } = data.data || {}
            const {currentStepIndex,finish,overLimit, crash, collisionAlarm,totalTime,score,isPass,completedPhotoCount,passedPhotoCount,stayPointData,proportionOffset} = taskData || {}
            let {horizonalDistance, verticalDistance} = homingData || {};
            state.guidStatus = openGuidStatu;
            if(notifyKeyList&&notifyKeyList.length>0)
            {
                notifyKeyList.forEach((item: string) => {
                    if (item == "l" || item == 'L') {
                        handleOpenAlbum();
                    }else if(item == "Escape")
                    {
                        if(state.currentPage == PageName.音频)
                        {
                            state.currentPage = PageName.飞行;
                        }else
                        {
                            handleBack('icon');
                        }
                    }else if(item == "F11"){
                        window.listenEvent.emit('toggle-full-screen');
                    }
                });
            }
            if(triggerReset)
            {
                reset(undefined,true);
            }
            if(state.canSetFps){
                state.fpsStatus = fps;
            }
            if(state.currentPointIndex != currentStepIndex &&  state.currentMessage != MassageType.无 && state.currentMessage != MassageType.解锁 ){
                if(state.currentMessage != MassageType.巡检){
                    state.currentMessage = MassageType.巡检;
                }
                proxy?.vknMessage.close()
                state.alarmType = AlarmType.操作;
                if(sceneCategory.value == SceneCategory.训练){
                    showMessage(`请进行“${state.taskList[state.currentTask]?.pointList[currentStepIndex]?.actionName}”拍摄`, "warning", 0,'yjzldy')
                }
            }

            if(!finish){
                if(unLockStatu == 1 && state.lockStatus != unLockStatu && state.currentMessage == MassageType.解锁){
                if((isAssessmentScene.value || sceneCategory.value == SceneCategory.通关) && state.isShowMessage){
                        proxy?.vknMessage.close();
                    }
                    proxy?.vknMessage.close()
                    state.currentMessage = MassageType.巡检;
                    state.alarmType = AlarmType.操作;
                    if(sceneCategory.value == SceneCategory.训练){
                        showMessage(`请进行“${currentPoint.value?.actionName}”拍摄`, "warning", 0,'yjzldy')
                    }
                }
                if(state.finish){
                    state.finish = false;
                }
                const prevIsReady = state.isReady;
                Object.assign(state,{
                    uavFlyStatus:flyStatu,
                    lockStatus:unLockStatu,
                    connectStatus:joyStickMode,
                    angleValue: yaw.toFixed(0),
                    homeAngle:(homingData?.yaw - yaw).toFixed(0),
                    stayPointHorzDistance:stayPointData?.horizonalDistance?.toFixed(1) || '0',
                    stayPointYaw:(stayPointData?.yaw - yaw).toFixed(0),
                    altitudeValue:altitude.toFixed(1),
                    speedValue:horizonalSpeed.toFixed(1),
                    relativeAltitude:verticalDistance.toFixed(1),
                    horizontalDistance:horizonalDistance.toFixed(1),
                    currentZoom:parseFloat(zoom),
                    audioMode:shootingMode,
                    recordTime:recordTime,
                    onGround:onGround,
                    currentPointIndex:currentStepIndex >= 0?currentStepIndex:0,
                    finish,
                    pitch,
                    // isShowAlarm:overLimit == 1?true:false,
                    currentWindSpeed:currentWindSpeed?.toFixed(1) || '0.0',
                    isReady,
                    currentFlyMode,
                    characterMode,
                    targetRatio:proportionOffset >= 0?(proportionOffset * 100).toFixed(0):proportionOffset,
                    signalStrength,
                    galeWarning,
                    collisionWarningLevels: collisionWarningLevels || [0, 0, 0, 0],
                    collisionWarningMinDistance: collisionWarningMinDistance || 0
                })
                // 广播 isReady 状态变化给布局组件（仅在状态变化时广播）
                if (isReady && isReady !== prevIsReady) {
                    window.listenEvent.emit('is-ready-change', isReady);
                }
                if(!state.showAudioView){
                    state.photoPic = photoPic;
                }

                if(unLockStatu == 0 && isReady && state.currentMessage == MassageType.无){
                    state.currentMessage = MassageType.解锁;
                    state.alarmType = AlarmType.操作;
                    showMessage($tips.OPEN_TIPS, "warning", 0,'yjzldy')
                }

                if(collisionAlarm && state.currentMessage != MassageType.碰撞){
                    state.currentMessage = MassageType.碰撞;
                    state.alarmType = AlarmType.异常;
                    proxy?.vknMessage.close();
                    showMessage("注意障碍物，谨慎飞行", 'redAlert', 3000, 'gjts')
                }

                if(!collisionAlarm && state.currentMessage == MassageType.碰撞){
                    state.currentMessage = MassageType.巡检;
                    state.promptText = "";
                    proxy?.vknMessage.close();
                }
            }
            if(finish && !state.finish){
                Object.assign(state,{
                    finish:true,
                    isShowAlarm:false,
                    startTime: 0,
                    remainingSeconds: 0,
                })
                stopProgress();
                if(sceneCategory.value == SceneCategory.训练 || isAssessmentScene.value ||
                    (sceneCategory.value == SceneCategory.通关 && state.alertType != AlertType.电量告警)){
                    proxy?.vknMessage.close();
                    Object.assign(state,{
                        alertType:AlertType.无,
                        startCoundow:true,//开启倒计时
                        totalTime,
                        crash,
                        gradScore:score != null && score != undefined?score.toFixed(0):0,//得分
                        evaluate:isPass,
                        passedPhotoCount,
                        completedPhotoCount,
                        allPhotoCount:state.taskList[state.currentTask].pointList.length,
                        currentPointIndex:state.taskList[state.currentTask].pointList.length - 1 > 0?state.taskList[state.currentTask].pointList.length - 1:0,
                        currentPage:PageName.成绩,
                    })
                }
                if(sceneCategory.value == SceneCategory.通关){
                    if(state.alertType == AlertType.电量告警){
                        setTimeout(() => {
                            reset();
                        }, 3500);
                    }
                }
            }

        }

        if(type === "notifyReferenceImage"){
            if(data.data && data.data?.url){
                state.referencePhoto = data.data.url;
            }
        }

        if(type === "notifyActionEvaluateParams"){
            if(data.data && data.data?.proportionOffset){
                let {minPassingValue} = data.data.proportionOffset || {};
                state.standardTargetRatio = minPassingValue > 0 ? Number((minPassingValue * 100).toFixed(0)) : 0;
            }
        }

        if (type === 'loadSceneResource') {
            // clearInterval(loadingState.timer)
            state.sceneIsLoaded = true;
            state.currentPage = PageName.飞行;
            setTimeout(() => {
                if(homeIcon.value){
                    state.homeIconW = homeIcon.value.offsetWidth;
                    state.homeIconH = homeIcon.value.offsetHeight;
                }
                if(homePos.value){
                    state.homeOutW = homePos.value.offsetWidth;
                    state.homeOutH = homePos.value.offsetHeight;
                }
                if(progressBox.value){
                    state.containerWidth = progressBox.value.offsetWidth;
                }
                if(stayPosRef.value){
                    state.stayBoxW = stayPosRef.value.offsetWidth;
                    state.stayBoxH = stayPosRef.value.offsetHeight;
                }

                if(document.getElementById('stayPosIcon')){
                    state.stayPointIconW = document.getElementById('stayPosIcon')?.clientWidth;
                    state.stayPointIconH = document.getElementById('stayPosIcon')?.clientHeight;
                }
            }, 300);

        }

        if (type === 'loadResourceFail') {
            showErrorMessage('考试场景资源加载失败，即将返回考试科目页面', 100);
            schedulePrompt(() => {
                handleBack();
            }, 3000);
        }

        if (type === 'modelLoading') {
            //加载中
            // const { progressData} = data.data || {}
            // loadingState.loadingStatus = progressData
            // initTimer();
            setLoadingStatus(data.data);

        }

        if(type ==='extraLoadModelFiles')
        {
            setExtraFileMap(data.data);
        }


        if(type === 'initializeEngineProgress'){
            state.engineProgress = data.data?.progress || 0
        }

        if(type === 'exitSimulateModuleSuccess'){
            if(state.backByExitSimulateModule){
                handleBack();
            }
        }
    })

    ////////////////////////////////////////////////// 方法

    /**
     * 解锁/锁定，手动锁定只有在无人机接触到地面时才支持。
     */
    function handleLock(){
        if(state.lockStatus == $enum.CommonStatus.open && !state.onGround) return;
        let unlock;
        if(state.lockStatus == $enum.CommonStatus.open){
            unlock = $enum.CommonStatus.close;
        }else{
            unlock = $enum.CommonStatus.open;
        }
        switchUnlockUav({unlock});
    }

    /**
     * 一键返航
     */
    function handleBackHome(automatic:any){
        if(state.galeWarning || state.uavFlyStatus == $enum.UAV_FLY_STATUS.WAITING || (!automatic && state.battery < 12)) return;  //大风预警, 电量不足并且是手动返航, 不支持一键返航
        if (state.uavFlyStatus == $enum.UAV_FLY_STATUS.BACKING && state.battery >= 12) {
            stopReturn();
            return;
        }
        if(state.uavFlyStatus == $enum.UAV_FLY_STATUS.FLYING){
            if(state.alertType == AlertType.电量告警){
                controlAlarm(false)
            }
            oneKeyReturn({force:true});
        }
    }

    //切换音频模式
    function handleChangeMode(){
      if(state.uavFlyStatus != $enum.UAV_FLY_STATUS.FLYING) return;
      if(state.audioMode == $enum.AUDIO_MODE.PHOTO){
        //当前是拍照模式
        if(state.photoStatus ==  $enum.CommonStatus.open){
          state.photoStatus =  $enum.CommonStatus.close;
          shoot();
        }
        switchShootingMode({shootingMode:$enum.AUDIO_MODE.VIDEO})
      }else if(state.audioMode == $enum.AUDIO_MODE.VIDEO){
        //当前是录像模式
        if(state.videoStatus ==  $enum.CommonStatus.open){
          state.videoStatus =  $enum.CommonStatus.close;
          shoot();
        }
        switchShootingMode({shootingMode:$enum.AUDIO_MODE.PHOTO})
      }
    }

    function handleTakePhoto(){
        if(state.uavFlyStatus != $enum.UAV_FLY_STATUS.FLYING) return;
        if(state.photoStatus == $enum.CommonStatus.open) return;
        shoot();
        state.photoStatus = $enum.CommonStatus.open;
        setTimeout(() => {
            state.photoStatus = $enum.CommonStatus.close;
        }, 800);
    }

    function handleTakeVideo(){
        if(state.uavFlyStatus != $enum.UAV_FLY_STATUS.FLYING) return;
        if(state.videoStatus == $enum.CommonStatus.close){
            //开启录屏
            state.videoStatus = $enum.CommonStatus.open;
        }else{
            //关闭录屏
            state.videoStatus = $enum.CommonStatus.close;
        }
        shoot();
    }

    /**************************************  变焦 **************************************/

    // 获取刻度位置
    function getMarkPosition(mark:any) {
        return ((mark - state.minZoom) / (state.maxZoom - state.minZoom)) * state.scaleRange
    }

    // 生成刻度标记
    function generateScaleMarks() {
      const marks = []
      for (let z = state.maxZoom; z >= state.minZoom; z -= state.zommStep) {
        marks.push(z)
      }
      state.scaleMarks = marks;
    }

    function zoomIn(){
        if(state.uavFlyStatus != $enum.UAV_FLY_STATUS.FLYING) return;
        const newZoom = state.currentZoom + state.zommStep;
        if (newZoom <= state.maxZoom + state.zommStep) {
            setZoom({zoom:Number(newZoom.toFixed(1))})
        }
    }

    function zoomOut(){
        if(state.uavFlyStatus != $enum.UAV_FLY_STATUS.FLYING) return;
        const newZoom = state.currentZoom - state.zommStep
        if (newZoom >= state.minZoom - state.zommStep) {
          setZoom({zoom:Number(newZoom.toFixed(1))})
        }
    }

    /**************************************  变焦 **************************************/

    function handleBack(type?: string) {
        enterOrExitUavSimulateModule({ enter: false })
        showOrHideEngineView(false)
        store.commit("persistence/setStationId", null);
        try {
            const value = sessionStorage.getItem('pilotAssessmentTrainingContext')
            if(value){
                const context = JSON.parse(value) as {
                    sessionId?: string | number
                    roundId?: string | number
                }
                if(context.sessionId && context.roundId){
                    router.push({
                        name: 'CandidateSubjects',
                        params: { sessionId: String(context.sessionId) },
                        query: { roundId: String(context.roundId) },
                    })
                    return
                }
            }
        } catch {
            sessionStorage.removeItem('pilotAssessmentTrainingContext')
        }
        router.push({
            path: '/home',
        })
    }

    function handleBackCallback(type?: string){
        state.backByExitSimulateModule = true;
        enterOrExitUavSimulateModule({enter:false});
    }

    /**************************************  表盘 **************************************/

    function startProgress(){
        if(!state.isComputing){
            state.isComputing = true;
        }
        state.startTime = Date.now();
        state.remainingSeconds = state.currentSeconds;
        if (timeBox.value) {
            timeBox.value.style.transition = 'transform 1.2s linear';
        }
        if (progressRef.value) {
            progressRef.value.style.transition = 'width 1.2s linear';
        }
        animateProgress();
    }

    function animateProgress(){
        const elapsed = (Date.now() - state.startTime) / 1000;
        state.currentSeconds = Math.ceil(Math.max(0, state.remainingSeconds - elapsed));

        // 更新进度和电量
        const progress = state.currentSeconds / state.totalSeconds;
        state.battery = Math.max(0, Math.ceil(progress * 100));

        // 更新UI
        const progressWidth = (1 - progress) * 100;
        const boxWidth = timeBox.value ? timeBox.value.offsetWidth : 0;
        const moveDistance = (state.containerWidth - boxWidth) * (1 - progress);

        if (timeBox.value) {
            timeBox.value.style.transform = `translateX(-${moveDistance}px)`;
        }
        if (progressRef.value) {
            progressRef.value.style.width = `${progressWidth}%`;
        }

        if (state.currentSeconds <= 0) {
            stopProgress();
        } else {
            state.animationId = requestAnimationFrame(animateProgress);
        }
    }

    function stopProgress() {
        if (state.isComputing) {
          state.isComputing = false;
        }
        if (state.animationId) {
          cancelAnimationFrame(state.animationId);
          state.animationId = null;
        }

        // 确保最终状态正确
        if (state.currentSeconds <= 0) {
          state.currentSeconds = 0;
          state.battery = 0;

          if (timeBox.value) {
            const boxWidth = timeBox.value.offsetWidth;
            const position = state.containerWidth - boxWidth;
            timeBox.value.style.transform = `translateX(-${position}px)`;
          }
          if (progressRef.value) {
            progressRef.value.style.width = `100%`;
          }
        }
    }

    /**************************************  任务信息 **************************************/

    async function getAirlineData(){
        let param = {
            stationId: state.stationdId,
            sceneInfoId:state.sceneInfo.id,
            airLineId:state.sceneInfo?.airLineId || state.sceneInfo?.stationList?.[0]?.airLineId
        }
        state.taskList = []
        state.currentTask = -1
        let {code, data} = await getAirLineDetailNew(param)
        if(code != $enum.EnumResult.SUCCESS){
            proxy?.vknMessage.error('获取任务数据失败！')
            return;
        }
        if(Array.isArray(data) && data.length > 0){
            state.taskList = [...data]
            state.currentTask = 0
        }else {
            state.taskList = [data]
            state.currentTask = 0
        }
    }
    async function handleSwitch(type: string){
        if(type == 'guid'){
            const enableGuide = !state.guidStatus
            let params = {
                userId: store.state.persistence.userInfo.userId,
                tenantId: store.state.persistence.currentTenantId,
                sceneTypeId: store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-2].id,
                enableGuide
            }
            let {code,data,message} = await saveUserTrainingSetting(params) as any
            if(code != $enum.EnumResult.SUCCESS || data != true){
                return;
            }

            store.commit('persistence/setUserTrainingSetting', {
                ...store.state.persistence.userTrainSettingInfo,
                enableGuide
            })
            switchOpenGuid({open:enableGuide?1:0});
        }else if(type == 'view'){
            switchView()
        }else{
            if(state.lockStatus == $enum.CommonStatus.open){
                state.referencePhoto = ''
                reset();
            }
        }
    }

    function handleSwitchSetting(type: string){
        let guideLineIds = store.state.persistence.userTrainSettingInfo.guideLineIds;
        if(guideLineIds){
            const ids = (Array.isArray(guideLineIds) ? guideLineIds : String(guideLineIds).split(','))
            .filter(Boolean).map(Number);
            setGuideLine(ids)
        }
        if(type == 'open'){
            state.currentPage = PageName.辅助线;
            setPause({statu:1})
        }else{
            state.currentPage = PageName.飞行;
            setPause({statu:0})
        }
    }

    function setGuideLine(guideLineIds:number[]){
        state.crossLine = guideLineIds.includes(1);
        state.gridLine = guideLineIds.includes(2);
        state.centerPoint = guideLineIds.includes(3);
    }

    async function handleConfirmGuideLine(){
        let guideLineIds = []

        if(state.crossLine){
            guideLineIds.push(1)
        }
        if(state.gridLine){
            guideLineIds.push(2)
        }
        if(state.centerPoint){
            guideLineIds.push(3)
        }
        let params =  {
            userId: store.state.persistence.userInfo.userId,
            tenantId: store.state.persistence.currentTenantId,
            sceneTypeId:
                state.sceneInfo?.sceneTypeId ||
                store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-2]?.id,
            guideLineIds: guideLineIds.join(','),
        }
        state.settingConfirmLoading = true;
        let {code, data, message} = await saveUserTrainingSetting(params)
        state.settingConfirmLoading = false;
        if(code != $enum.EnumResult.SUCCESS || data != true){
            showErrorMessage('保存辅助线失败')
            return;
        }
        store.commit('persistence/setUserTrainingSetting', {
            ...store.state.persistence.userTrainSettingInfo,
            guideLineIds: guideLineIds.join(','),
        });
        handleSwitchSetting('close')
    }

    function handleToggleGuideLine(type: string){
        if(type == 'cross'){
            state.crossLine = !state.crossLine
        }else if(type == 'grid'){
            state.gridLine = !state.gridLine
        }else if(type == 'center'){
            state.centerPoint = !state.centerPoint
        }
    }

    async function handleResetGuideLine(){
        let {code, data, message} = await getDefaultTrainingSetting({}) as any
        if(code != $enum.EnumResult.SUCCESS || (!data || Object.keys(data).length == 0)){
            showErrorMessage('恢复默认辅助线失败')
            return;
        }
        let {guideLineIds} = data || {}
        const ids = (Array.isArray(guideLineIds) ? guideLineIds : String(guideLineIds).split(','))
        .filter(Boolean).map(Number);
        setGuideLine(ids)
    }

    function reset(trainingId?:string | number | null,fromNotify = false){
        if (!fromNotify) {
            let data = {} as any
            if (sceneCategory.value == SceneCategory.训练 || (sceneCategory.value == SceneCategory.通关 && state.sceneInfo?.difficultyType == 0)) {
                state.currentFlyMode = FlyMode.GPS
            }

            if (isAssessmentScene.value || (sceneCategory.value == SceneCategory.通关 && state.sceneInfo?.difficultyType == 1)) {
                state.currentFlyMode = FlyMode.混合
            }
            //重置时恢复默认
            data.flyMode = state.currentFlyMode
            if (trainingId) {
                data.trainingId = trainingId
            }
            if(isAssessmentScene.value){
                data.windSpeed = createRandomWind().speed
                data.windDirection = createRandomWind().direction
            }
            if(sceneCategory.value == SceneCategory.训练){
                data.openGuidStatu = state.guidStatus
            }
            data.canvasLimitHeight = getCanvasLimitHeight(store.state.persistence.resolution)
            resetView(data)
        }
        stopProgress();
        stop()
        skipDialRotationWatch = true;
        Object.assign(state, {
            totalSeconds: store.state.persistence.currentUavInfo.flyTime * 60,
            currentSeconds: store.state.persistence.currentUavInfo.flyTime * 60,
            pitch:0,
            finish: false,
            uavFlyStatus:$enum.UAV_FLY_STATUS.WAITING,
            battery: 100 as any, //电池,
            connectStatus: $enum.CommonStatus.close,
            lockStatus:$enum.CommonStatus.close,
            audioMode:$enum.AUDIO_MODE.PHOTO,
            videoStatus:$enum.CommonStatus.close,
            photoStatus:$enum.CommonStatus.close,
            recordTime:0, //录制时间
            showAudioView:false, //是否显示音频
            photoPic:null,
            isShowAudio:false,
            currentZoom:1.0,//当前变焦
            angleValue:0, //角度
            speedValue: 0,//速度
            altitudeValue: 0,//高度
            relativeAltitude:0,//相对起始点的高度
            horizontalDistance:0,//相对起始点的水平距离
            yawAngle:0,//返航点角度
            totalRotation: 0,
            onGround:false, //是否在地面
            currentTask:0,//当前选中的任务下标
            currentPointIndex:0,
            startTime: 0,
            remainingSeconds: 0,
            fpsStatus:60,
            canSetFps:true,
            currentWindSpeed:'0.0',
            isReady:false,
            currentFlyMode:FlyMode.GPS,
            alarmType:AlarmType.操作,
            alertType:AlertType.无,
            promptText:'',
            currentMessage:MassageType.解锁,
            isAlwaysVisibleAi:true,
            isShowAlarm:false,
            // isClickBack:false,
        })
        nextTick(() => {
            skipDialRotationWatch = false;
        });
        if (timeBox.value) {
            timeBox.value.style.transform = `translateX(0px)`;
        }
        if (progressRef.value) {
            progressRef.value.style.width = `0%`;
        }
        if(state.alarmTimer){
            controlAlarm(false);
        }
        schedulePrompt(() => {
            proxy?.vknMessage.close();
            showMessage($tips.OPEN_TIPS, "warning", 0,'yjzldy')
        }, 200);
    }

    function handleShowTaskList(){
        if(state.taskList.length == 0){
            return;
        }
        state.isShowTaskList = true
    }



    /**************************************  成绩 **************************************/
    async function handleRestart(){
        let windPower:any = null
        if(sceneCategory.value == SceneCategory.训练){
            windPower = store.state.persistence.userTrainSettingInfo.windPower
        }
        let param = {
            sceneId:store.state.persistence.currentUavInfo.sceneInfo.id,
            uavSpecificationId:state.uavId,
            userId:store.state.persistence.userInfo.userId,
            airLineId:currentTaskInfo.value?.id,
            difficultyType:state.sceneInfo?.difficultyType,
            windPower:windPower,
            stationId:state.stationdId,
        }
        const {code, data} = await createTraining(param);
        if(code != $enum.EnumResult.SUCCESS){
            showErrorMessage("创建新训练失败，请稍后再试", 100);
            return;
        }
        const {trainingId} = data as any || {};
        //2. 通过后端返回的trainingid更新store里面的trainingid
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: trainingId
        });
        //3. 调用webapi接口重新开始
        reset(trainingId);
        Object.assign(state,{
            startCoundow:false,//开启倒计时
            isShowMessage:false,
            fromToAudio:PageName.飞行, //从哪个页面切换到音频
            alertType:AlertType.无,
            currentPage:PageName.飞行, //当前页面,
            referencePhoto:''
        })
        // showMessage($tips.OPEN_TIPS, "warning", 0,'yjzldy')
    }

    function handleBeforeUnload(event: BeforeUnloadEvent) {
        store.commit("viewData/setEnterScene", false);
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: null
        });
        // handleBack();
    }

    function backFromAudio(){
        state.currentPage = state.fromToAudio;
        if(state.fromToAudio == PageName.成绩){
            state.startCoundow = true;
        }
    }

    function handleVisibilityChange(){
        if(document.visibilityState == "hidden"){
            state.pageVisible = false;
            state.canSetFps = false;
        }else{
            setTimeout(() => {
                state.pageVisible = true;
            }, 300);
            setTimeout(() => {
                state.canSetFps = true;
            }, 1500);
        }
    }
    function handleKeyDown(event:any)
    {
        if(state.currentPage == PageName.音频)
        {
            return;
        }
        if (state.currentPage == PageName.成绩) {
            if (event.key == "Escape") {
                handleBack('icon');
            }
            return;
        }
        forceGainFocus({key: event.key});
    }

    /**
     * 打开相册
     */
    function handleOpenAlbum(){
        state.currentPage = PageName.音频;
        state.fromToAudio = PageName.飞行;
    }

    function handleSwitchFlyMode(){
        if(sceneCategory.value == SceneCategory.通关 || isAssessmentScene.value){
            return
        }
        if(state.signalStrength == SignalStrength.无 || state.signalStrength == SignalStrength.弱) return;
        window?.playClick()
        let flyMode = state.currentFlyMode == FlyMode.GPS?0:1;
        switchFlyMode({flyMode:flyMode})
    }

    //下载报告
    async function handleDownload(){
        window?.playClick();
        state.loading = true;
        const response = await exportAirLinePointActions({id:trainingId.value}) as any;
        state.loading = false;
        if(response?.status !== 200){
            showErrorMessage("下载报告失败，请稍后再试", 40);
            return
        }
        downloadFile(response, 'docx')
    }

    //打开pdf

    function handleFinish(){
        reset();
    }
    ////////////////////////////////////////////////// 生命周期
    onBeforeMount(() => {
        if(!store.state.viewData.enterScene){
            showOrHideEngineView(true)
            store.commit("viewData/setEnterScene", true);
        }
        generateScaleMarks();
        getAirlineData();

        //获取辅助线设置
        const guideLineIds = store.state.persistence.userTrainSettingInfo.guideLineIds;
        if(guideLineIds){
            const ids = (Array.isArray(guideLineIds) ? guideLineIds : String(guideLineIds).split(','))
                .filter(Boolean)
                .map(Number);
            setGuideLine(ids)
        }
    })

    onBeforeUnmount(()=>{
        isUnmounted = true
        clearPendingPrompts()
        stop()
        if(!state.backByExitSimulateModule){
            enterOrExitUavSimulateModule({enter:false})
        }
        showOrHideEngineView(false)
        store.commit("viewData/setEnterScene", false);
        proxy?.vknMessage.close();
        if(state.alarmTimer){
            controlAlarm(false);
        }
        stopProgress();
        window.removeEventListener('beforeunload', handleBeforeUnload);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        document.removeEventListener('keydown',handleKeyDown );
    })

    onMounted(() => {
        window.addEventListener('beforeunload', handleBeforeUnload)
        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.addEventListener('keydown', handleKeyDown);
    })

    return {
        ...toRefs(state),
        ...toRefs(loadingState),
        uavCurrentStatus,
        batteryIcon,
        connectIcon,
        progressTimer,
        lockIcon,
        $enum,
        changeModeIcon,
        videoIcon,
        photoIcon,
        takeVideoTime,
        zoomPoint,
        dialStyle,
        positionStyle,
        PageName,
        currentTaskInfo,
        currentPoint,
        percentage,
        pitchTop,
        AlertType,
        engineInitialized,
        loadingProgess,
        FlyMode,
        SceneCategory,
        sceneCategory,
        isAssessmentScene,
        MassageType,
        CharacterMode,
        gradTotalTime,
        stayPointStyle,
        showTargetProgress,
        SignalStrength,
        trainingId,
        isPilotAssessment,
        backFromAudio,
        handleBack,
        handleBackCallback,
        handleLock,
        handleBackHome,
        handleChangeMode,
        handleTakePhoto,
        handleTakeVideo,
        zoomIn,
        zoomOut,
        getMarkPosition,
        handleSwitch,
        handleRestart,
        handleShowTaskList,
        handleOpenAlbum,
        handleOpenPDF,
        handleSwitchFlyMode,
        handleOpenSettingFullscreen,
        handleSwitchSetting,
        handleToggleGuideLine,
        handleResetGuideLine,
        speak,
        stop,
        handleDownload,
        handleFinish,
        handleConfirmGuideLine
    }
}
